<template>
  <div class="container">
    <div class="card">
      <router-link :to="{ name: 'game-login' }">
        <img class="logo" src="/images/logo-font-white.svg" alt="Logo yuzu" />
      </router-link>
      <div class="block">
        <h2>Mot de passe oublié ?</h2>
        <p>
          Saisissez l’adresse e-mail que vous utilisez habituellement pour vous
          connecter à Yuzu.
        </p>
      </div>
      <VForm
        :button="{
          label: 'Réinitialiser votre mot de passe',
          class: 'primary full-size',
          hotDisabled: true,
        }"
        :clean="true"
        :displayErrors="false"
        :callback="sendResetLink"
      >
        <template #form-body>
          <VField
            type="email"
            label="Entrez votre adresse e-mail"
            placeholder="adresse@email.com"
            name="email"
            v-model="state.email"
            rules="required|email"
            :displayError="true"
          />
        </template>
      </VForm>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useToast } from "vue-toastification";
import { useCandidateStore } from "@/stores/candidate.js";

const { forgotPassword } = useCandidateStore();

const toast = useToast();

const state = reactive({
  email: "",
});

async function sendResetLink() {
  if (state.email) {
    await forgotPassword(state.email);

    state.email = "";

    toast(
      "Un mail a été envoyé à l'adresse fournie. Suivez les instructions du mail pour réinitialiser votre mot de passe.",
      {
        type: "success",
      }
    );
  }
}
</script>
